module.exports = __webpack_public_path__ + "static/join-small-a3e3bdd865f711d4416b8239e8073ae9.jpg";